"use strict";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { OnchainItemListOptionType } from "components/lists/items/types";
import { selectWatchedAddressSet } from "features/favorites/selectors";
export function useFavoriteWalletOptions({ skip }) {
  const favoriteWalletsSet = useSelector(selectWatchedAddressSet);
  return useMemo(() => {
    if (skip) {
      return void 0;
    }
    return Array.from(favoriteWalletsSet).map((address) => ({
      type: OnchainItemListOptionType.WalletByAddress,
      address
    }));
  }, [favoriteWalletsSet, skip]);
}
